import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { GlobalComponent } from "../../global-component";
import { TokenStorageService } from '../../core/services/token-storage.service';
import { createRazorpayOrder, createRazorpayOrderFailure, createRazorpayOrderSuccess, createTransactionsRecord, createTransactionsRecordFailure, createTransactionsRecordSuccess, fetchAllDataoperators, fetchAllDataoperatorsFailure, fetchAllDataoperatorsSuccess, fetchAllPrelimEngineers, fetchAllPrelimEngineersFailure, fetchAllPrelimEngineersSuccess, fetchAllProductionEngineers, fetchAllProductionEngineersFailure, fetchAllProductionEngineersSuccess, fetchAllQcEngineers, fetchAllQcEngineersFailure, fetchAllQcEngineersSuccess, fetchAllStampingEngineers, fetchAllStampingEngineersFailure, fetchAllStampingEngineersSuccess, fetchAllSurveyors, fetchAllSurveyorsFailure, fetchAllSurveyorsSuccess, fetchCounts, fetchCountsFailure, fetchCountsSuccess, fetchNotificationData, fetchNotificationDataFailure, fetchNotificationDataSuccess, fetchSingleTransaction, fetchSingleTransactionFailure, fetchSingleTransactionSuccess, fetchStampingPartnerCounts, fetchStampingPartnerCountsFailure, fetchStampingPartnerCountsSuccess, fetchTimelineData, fetchTimelineFailure, fetchTimelineSuccess, fetchTransactionsData, fetchTransactionsDataFailure, fetchTransactionsDataSuccess, fetchTransactionsStatsData, fetchTransactionsStatsDataFailure, fetchTransactionsStatsDataSuccess, fetchUnreadNotifications, fetchUnreadNotificationsFailure, fetchUnreadNotificationsSuccess, fetchVendorAllClients, fetchVendorAllClientsFailure, fetchVendorAllClientsSuccess, fetchVendorSelectedClient, fetchVendorSelectedFailure, fetchVendorSelectedSuccess, fileDeleteOnServer, fileDeleteOnServerFailure, fileDeleteOnServerSuccess, fileUploadOnServer, fileUploadOnServerFailure, fileUploadOnServerSuccess, globalsearch, globalsearchFailure, globalsearchSuccess, markAllNotificationAsRead, markAllNotificationAsReadFailure, markAllNotificationAsReadSuccess, updateSingleTransaction, updateSingleTransactionFailure, updateSingleTransactionSuccess, updateUnreadNotifications, updateUnreadNotificationsFailure, updateUnreadNotificationsSuccess, fetchTickerMessage, fetchTickerMessageFailure, fetchTickerMessageSuccess } from './common.actions';
import { CommonAPIService } from '../../core/services/common-api.service';
import { ToastifyService } from '../../shared/toastify-service';
import { GenericService } from '../../core/services/generic.service';

const VENDOR_COLL_NAME = GlobalComponent.vendorcollname;
@Injectable()
export class CommonEffects {


  fetchCounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchCounts),
      mergeMap(() => {
        let currentuser = this.tokenService.getUser();
        let isuservendor = this.genericService.getUserIsVendor();
        let vendordocs;
        if (!isuservendor) {
          let clientguid = currentuser.guid;
          if (currentuser.role && currentuser.role.type != 'super_admin') {
            clientguid = currentuser.masterguid;
          }
          vendordocs = this.afs.collection(VENDOR_COLL_NAME).doc(this.tokenService.getVendorGUID()!).collection('clients').doc(clientguid);
          return vendordocs.valueChanges().pipe(map((docs: any) => {
            return fetchCountsSuccess({ countsobj: docs });
          }),
            catchError((error) => {
              return of(fetchCountsFailure({ error }))
            }))
        } else {
          vendordocs = this.afs.collection(VENDOR_COLL_NAME).doc(this.tokenService.getVendorGUID()!);
          return vendordocs.valueChanges().pipe(map((docs: any) => {
            console.log("fetchCountsSuccess", docs)
            return fetchCountsSuccess({ countsobj: docs });
          }),
            catchError((error) => {
              return of(fetchCountsFailure({ error }))
            }))
        }
      })
    )
  );

  //TIMELINE DATA
  fetchTimelineData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTimelineData),
        mergeMap(({ pathurl }) =>
          this.commonService.fetchTimeline(pathurl).pipe(
            map((data) => {
              let timelines = data;
              return fetchTimelineSuccess({ timelines })
            }),
            catchError((error) => {
              console.log("inside timeline error", error);
              return of(fetchTimelineFailure({ error }))
            })
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF TIMELINE API
  fetchTimelineFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTimelineFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH TRANSACTION STATS DATA
  fetchTransactionsStatsData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTransactionsStatsData),
        mergeMap(() =>
          this.commonService.fetchTransactionsStats().pipe(
            map((data) => {
              return fetchTransactionsStatsDataSuccess({ stats: data });
            }),
            catchError((error) => of(fetchTransactionsStatsDataFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF TRANSACTION STATS API
  fetchTransactionsStatsDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTransactionsStatsDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH TRANSACTION DATA
  fetchTransactionsData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTransactionsData),
        mergeMap(({ limit, skip }) =>
          this.commonService.fetchTransactions(limit, skip).pipe(
            map((data) => {
              return fetchTransactionsDataSuccess({ transactions: data });
            }),
            catchError((error) => of(fetchTransactionsDataFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF TRANSACTION API
  fetchTransactionsDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTransactionsDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH TRANSACTION DATA
  createTransactionsRecord$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createTransactionsRecord),
        mergeMap(({ postdata }) =>
          this.commonService.createTransaction(postdata).pipe(
            map((data) => {
              return createTransactionsRecordSuccess({ transactiondata: data.data });
            }),
            catchError((error) => of(fetchTransactionsDataFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF TRANSACTION CREATE SUCCESS
  createTransactionsRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createTransactionsRecordSuccess),
        tap((response) => {
          console.log("response", response);
          if (response.transactiondata.attributes!.iswalletrecharge) {
            this.toastifyService.showSuccessMessage('Wallet Recharged Successfully');
          }
        })
      ),
    { dispatch: false }
  );

  //SHOW ERROR MESSAGE OF TRANSACTION CREATE FAILURE
  createTransactionsRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createTransactionsRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //RAZORPAY ORDER CREATE
  createRazorpayOrder$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRazorpayOrder),
        mergeMap(({ postdata }) =>
          this.commonService.createRazorpayOrder(postdata).pipe(
            map((data) => {
              return createRazorpayOrderSuccess({ orderdata: data });
            }),
            catchError((error) => of(createRazorpayOrderFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF RAZORPAY ORDER CREATE API
  createRazorpayOrderFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRazorpayOrderFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
 * FETCH CLIENTS LIST OF ANY VENDOR
 */
  fetchVendorAllClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchVendorAllClients),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.vendorcollname + '/' + this.tokenService.getVendorGUID() + '/clients', ref => ref.where('basicdetails.blocked', '==', false))
          .valueChanges().pipe(
            map((docs: any) => {
              console.log("All Clients", docs)
              const clients = docs.map((doc: any) => doc.basicdetails);
              const servicecounts = docs.map((doc: any) => doc.servicecounts);
              return fetchVendorAllClientsSuccess({ clients, servicecounts });
            }),
            catchError((error) =>
              of(fetchVendorAllClientsFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchVendorAllClientsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchVendorAllClientsFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  //FILE UPLOAD ON SERVER
  fileUploadOnServer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fileUploadOnServer),
        mergeMap(({ postdata }) =>
          this.commonService.uploads3fileonserver(postdata).pipe(
            map(() => {
              return fileUploadOnServerSuccess();
            }),
            catchError((error) => of(fileUploadOnServerFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF RAZORPAY ORDER CREATE API
  fileUploadOnServerFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fileUploadOnServerFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FILE UPLOAD ON SERVER
  globalsearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(globalsearch),
        mergeMap(({ searchText, requesttype }) =>
          this.commonService.globalSearch(searchText, requesttype).pipe(
            map((res: any) => {
              return globalsearchSuccess({ searchRecords: res });
            }),
            catchError((error) => of(globalsearchFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF RAZORPAY ORDER CREATE API
  globalsearchFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(globalsearchFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FILE DELETE ON SERVER
  fileDeleteOnServer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fileDeleteOnServer),
        mergeMap(({ fileId }) =>
          this.commonService.deletes3fileonserver(fileId).pipe(
            map(() => {
              return fileDeleteOnServerSuccess();
            }),
            catchError((error) => of(fileDeleteOnServerFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF RAZORPAY ORDER CREATE API
  fileDeleteOnServerFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fileDeleteOnServerFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  fetchNotificationData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchNotificationData),
        mergeMap(({ userid }) =>
          this.commonService.fetchNotifications(userid).pipe(
            map((data) => {
              let notifications = data;
              console.log("notifications....", notifications);
              return fetchNotificationDataSuccess({ notifications })
            }),
            catchError((error) => {
              console.log("inside notification error", error);
              return of(fetchNotificationDataFailure({ error }))
            })
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF NOTIFICATION API
  fetchNotificationDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchNotificationDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //Mark all notificaitons as read
  markAllNotificationAsRead$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(markAllNotificationAsRead),
        mergeMap(() =>
          this.commonService.markAllasReadNotification().pipe(
            map(() => {
              return markAllNotificationAsReadSuccess();
            }),
            catchError((error) => of(markAllNotificationAsReadFailure({ error })))
          )
        ),
      ),
  );

  markAllNotificationAsReadSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(markAllNotificationAsReadSuccess),
        tap((response) => {
          console.log("response", response);
          this.toastifyService.showSuccessMessage('All notifications mark read successfully.');
        })
      ),
    { dispatch: false }
  );

  markAllNotificationAsReadFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(markAllNotificationAsReadFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH ALL UNREAD NOTIFICATIONS
  fetchUnreadNotifications$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchUnreadNotifications),
        mergeMap(() =>
          this.commonService.getUnreadNotifications().pipe(
            map((data) => {
              return fetchUnreadNotificationsSuccess({ notifications: data });
            }),
            catchError((error) => of(fetchUnreadNotificationsFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF NOTIFICATION API
  fetchUnreadNotificationsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchUnreadNotificationsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH ALL UNREAD NOTIFICATIONS
  updateUnreadNotifications$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateUnreadNotifications),
        mergeMap(({ id, postdata }) =>
          this.commonService.putNotification(id, postdata).pipe(
            map((data) => {
              return updateUnreadNotificationsSuccess({ notifications: data });
            }),
            catchError((error) => of(updateUnreadNotificationsFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF NOTIFICATION API
  updateUnreadNotificationsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateUnreadNotificationsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH SINGLE TRANSACTION
  fetchSingleTransaction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSingleTransaction),
        mergeMap(({ postdata }) =>
          this.commonService.getSingleTransaction(postdata).pipe(
            map((data) => {
              return fetchSingleTransactionSuccess({ transaction: data });
            }),
            catchError((error) => of(fetchSingleTransactionFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF TRANSACTION API
  fetchSingleTransactionFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSingleTransactionFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH SINGLE TRANSACTION
  updateSingleTransaction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateSingleTransaction),
        mergeMap(({ id, postdata }) =>
          this.commonService.updateTransaction(id, postdata).pipe(
            map((data) => {
              return updateSingleTransactionSuccess({ transaction: data });
            }),
            catchError((error) => of(updateSingleTransactionFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF TRANSACTION API
  updateSingleTransactionFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateSingleTransactionFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH STAMPING PARTNER COUNTS
  fetchStampingPartnerCounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchStampingPartnerCounts),
      mergeMap(() => {
        let currentuser = this.tokenService.getUser();
        let stampingpartnerdocs;
        let stampingpartnerguid = currentuser.guid;
        if (currentuser.role && currentuser.role.type != 'super_admin') {
          stampingpartnerguid = currentuser.masterguid;
        }
        stampingpartnerdocs = this.afs.collection(VENDOR_COLL_NAME).doc(this.tokenService.getVendorGUID()!).collection('stampingpartners').doc(stampingpartnerguid);
        return stampingpartnerdocs.valueChanges().pipe(map((docs: any) => {
          return fetchStampingPartnerCountsSuccess({ countsobj: docs });
        }),
          catchError((error) => {
            return of(fetchStampingPartnerCountsFailure({ error }))
          }))
      })
    )
  );

  /**
   * FETCH SELECTED CLIENT OF ANY VENDOR
   */
  fetchVendorSelectedClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchVendorSelectedClient),
      mergeMap(({ clientguid }) =>
        //firebase
        this.afs.collection(GlobalComponent.vendorcollname + '/' + this.tokenService.getVendorGUID() + '/clients', ref => ref.where('basicdetails.guid', '==', clientguid))
          .valueChanges().pipe(
            map((docs: any) => {
              console.log("docs details", docs);
              return fetchVendorSelectedSuccess({ clientdetails: docs[0] });
            }),
            catchError((error) =>
              of(fetchVendorSelectedFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchVendorSelectedFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchVendorSelectedFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  // FETCH ALL DATAOPERATOR
  fetchAllDataoperators$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAllDataoperators),
        mergeMap(() =>
          this.commonService.getAllDataoperators().pipe(
            map((data) => {
              return fetchAllDataoperatorsSuccess({ dataoperators: data });
            }),
            catchError((error) => of(fetchAllDataoperatorsFailure({ error })))
          )
        ),
      ),
  );

  // FETCH ALL PRELIMENGINEERS
  fetchAllPrelimEngineers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAllPrelimEngineers),
        mergeMap(() =>
          this.commonService.getAllPrelimEngineers().pipe(
            map((data) => {
              return fetchAllPrelimEngineersSuccess({ prelimengineers: data });
            }),
            catchError((error) => of(fetchAllPrelimEngineersFailure({ error })))
          )
        ),
      ),
  );

  // FETCH ALL PRELIMENGINEERS
  fetchAllProductionEngineers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAllProductionEngineers),
        mergeMap(() =>
          this.commonService.getAllProductionEngineers().pipe(
            map((data) => {
              return fetchAllProductionEngineersSuccess({ productionengineers: data });
            }),
            catchError((error) => of(fetchAllProductionEngineersFailure({ error })))
          )
        ),
      ),
  );

  // FETCH ALL PRELIMENGINEERS
  fetchAllQcEngineers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAllQcEngineers),
        mergeMap(() =>
          this.commonService.getAllQcEngineers().pipe(
            map((data) => {
              return fetchAllQcEngineersSuccess({ qcengineers: data });
            }),
            catchError((error) => of(fetchAllQcEngineersFailure({ error })))
          )
        ),
      ),
  );

  // FETCH ALL PRELIMENGINEERS
  fetchAllStampingEngineers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAllStampingEngineers),
        mergeMap(() =>
          this.commonService.getAllStampingEngineers().pipe(
            map((data) => {
              return fetchAllStampingEngineersSuccess({ stampingengineers: data });
            }),
            catchError((error) => of(fetchAllStampingEngineersFailure({ error })))
          )
        ),
      ),
  );

  fetchTickerMessage$ = createEffect(
    () => 
      this.actions$.pipe(
        ofType(fetchTickerMessage),
        tap(()=>{
          console.log("Ticker Effect Working..!");
        }),
        mergeMap(()=>
        this.commonService.getTickerMessages().pipe(
          map((data)=> {
            return fetchTickerMessageSuccess({tickernews : data});
          }),
          catchError((error) => of(fetchTickerMessageFailure({ error })))
        )
      ),
    ),
  );
    
  // FETCH ALL SURVEYORS
  fetchAllSurveyors$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchAllSurveyors),
        mergeMap(() =>
          this.commonService.getAllSurveyors().pipe(
            map((data : any) => {
              return fetchAllSurveyorsSuccess({ surveyors: data });
            }),
            catchError((error) => of(fetchAllSurveyorsFailure({ error })))
          )
        ),
      ),
  );

  constructor(
    @Inject(Actions) private actions$: Actions,
    private afs: AngularFirestore,
    private tokenService: TokenStorageService,
    private commonService: CommonAPIService,
    private toastifyService: ToastifyService,
    private genericService: GenericService) { }
}